export function XML_CreateBoxPath(bounds, boxShape, drawElement) {
  drawElement.CreatePath(bounds, boxShape);
}
